<bn-loading-overlay></bn-loading-overlay>

<div class="container" *ngIf="model">

  <div class="row">
    <div class="col">
      <h3>
        Cesta
        <small *ngIf="model.id" class="text-muted">(#ID: {{ model.id }})</small>
      </h3>
    </div>
    <div class="col-auto">
      <button type="button" class="btn btn-primary" [disabled]="pesquisado" (click)="voltarParaLista()"
        [ngClass]="formTranche.pristine ? 'btn-primary' : 'btn-danger' ">
        {{ modoEdicao ? "Cancelar" : "Voltar"}}
      </button>

      <button *ngIf="modoEdicao" type="button" class="btn btn-primary"
        [disabled]="!permissaoEdicao || !formTranche.valid " (click)="salvar()">Salvar
      </button>

      <button *ngIf="!modoEdicao && permissaoEdicao && abaAtiva === 'dados-basicos'" type="button"
        class="btn btn-primary" [disabled]="pesquisado" (click)="habilitarEdicao()">Editar
      </button>
    </div>
  </div>
  <div *ngIf="formTranche" [formGroup]="formTranche">
    <ul ngbNav #nav="ngbNav" class="col nav-tabs" (navChange)="onTabChange($event)">
      <li [ngbNavItem]="'dados-basicos'" id="dados-basicos" title="Dados Básicos">
        <button ngbNavLink>Dados Básicos</button>
        <ng-template ngbNavContent>
          <div class="row">

            <div class="bn-form-group col-md-3">
              <label><b>Número da cesta</b></label>
              <input class="form-control" name="numeroTranche" id="numeroTranche" formControlName="numeroTranche"
                [readonly]="!modoEdicao" />
            </div>

            <div class="bn-form-group col-md-3">
              <label><b>Tipo cálculo limite Global:</b></label>
              <select type="text" id="idTipoCalculoLimite" class="form-select" formControlName="idTipoCalculoLimite"
                [attr.disabled]="!modoEdicao ? true : null">
                <option [value]="opcao.numero" *ngFor="let opcao of opcoesEdicaoTipoCalculoLimite">
                  {{opcao.numero}} - {{opcao.nome}}
                </option>
              </select>
            </div>

            <div class="bn-form-group col-md-3">
              <label><b>Tipo cálculo limite AF: <i class="fa fa-question-circle help-subtitulo" placement="bottom"
                    ngbTooltip="Não se aplica ao PEAC Crédito Solidário."></i></b></label>
              <select type="text" id="idTipoCalculoLimiteAgenteFinanceiro" class="form-select"
                formControlName="idTipoCalculoLimiteAgenteFinanceiro" [attr.disabled]="!modoEdicao ? true : null">
                <option [value]="opcao.numero" *ngFor="let opcao of opcoesEdicaoTipoCalculoLimite">
                  {{opcao.numero}} - {{opcao.nome}}
                </option>
              </select>
            </div>

            <div class="bn-form-group col-md-3">
              <label><b>Data início contratação</b></label>
              <bn-datepicker name="dataInicioContratacao" ngDefaultControl formControlName="dataInicioContratacao"
                [disabled]="!modoEdicao">
              </bn-datepicker>
            </div>

            <div class="bn-form-group col-md-3">
              <label><b>Data fim contratação</b></label>
              <bn-datepicker name="dataFimContratacao" ngDefaultControl formControlName="dataFimContratacao"
                [disabled]="!modoEdicao"></bn-datepicker>
            </div>

            <div class="bn-form-group col-md-3">
              <label><b>Data início protocolo</b></label>
              <bn-datepicker name="dataInicioProtocolo" ngDefaultControl formControlName="dataInicioProtocolo"
                [disabled]="!modoEdicao">
              </bn-datepicker>
            </div>

            <div class="bn-form-group col-md-3">
              <label><b>Data fim protocolo</b></label>
              <bn-datepicker name="dataFimProtocolo" ngDefaultControl formControlName="dataFimProtocolo"
                [disabled]="!modoEdicao"></bn-datepicker>
            </div>

            <div class="bn-form-group col-md-3">
              <label><b>Data fim liberação</b></label>
              <bn-datepicker name="dataFimLiberacoes" ngDefaultControl formControlName="dataFimLiberacoes"
                [disabled]="!modoEdicao"></bn-datepicker>
            </div>

            <div class="bn-form-group col-md-3">
              <label><b>Data fim retificação</b></label>
              <bn-datepicker name="dataFimRetificacoes" ngDefaultControl formControlName="dataFimRetificacoes"
                [disabled]="!modoEdicao">
              </bn-datepicker>
            </div>

            <div class="bn-form-group col-md-3">
              <label><b>Data início cobrança ECG</b></label>
              <bn-datepicker name="dataInicioCobrancaEcg" ngDefaultControl formControlName="dataInicioCobrancaEcg"
                [disabled]="!modoEdicao">
              </bn-datepicker>
            </div>

            <div class="bn-form-group col-md-3">
              <label><b>Data fim cobrança ECG</b></label>
              <bn-datepicker name="dataFimCobrancaEcg" ngDefaultControl formControlName="dataFimCobrancaEcg"
                [disabled]="!modoEdicao">
              </bn-datepicker>
            </div>

            <div class="bn-form-group col-md-3">
              <label><b>Qtde. dias limite retificação</b></label>
              <input min="0" class="form-control" name="quantidadeDiasLimiteRetificacao" ngDefaultControl
                formControlName="quantidadeDiasLimiteRetificacao" bnMask="INTEIRO" [readonly]="!modoEdicao" />
            </div>

            <div class="bn-form-group col-md-3">
              <label><b>Qtde. dias limite aditivo</b></label>
              <input min="0" class="form-control" bnMask="INTEIRO" name="quantidadeDiasLimiteAditivo" ngDefaultControl
                formControlName="quantidadeDiasLimiteAditivo" [readonly]="!modoEdicao" />
            </div>

            <div class="bn-form-group col-md-3">
              <label><b>Faturamento mínimo</b></label>
              <input class="form-control" bnMask="MOEDA" name="valorFaturamentoMinimo" ngDefaultControl
                formControlName="valorFaturamentoMinimo" [readonly]="!modoEdicao" />
            </div>

            <div class="bn-form-group col-md-3">
              <label><b>Faturamento máximo</b></label>
              <input class="form-control" name="valorFaturamentoMaximo" bnMask="MOEDA" ngDefaultControl
                formControlName="valorFaturamentoMaximo" [readonly]="!modoEdicao" />
            </div>

            <div class="bn-form-group col-md-3">
              <label><b>Valor crédito mínimo</b></label>
              <input class="form-control" bnMask="MOEDA" name="valorCreditoMinimo" ngDefaultControl
                formControlName="valorCreditoMinimo" [readonly]="!modoEdicao" />
            </div>

            <div class="bn-form-group col-md-3 ">
              <label><b> % garantido emb. taxa stop loss </b>
                <i class="fa fa-question-circle help-subtitulo" placement="top-right" ngbTooltip="
               Indica se o percentual garantido está embutido na taxa de Stop Loss"></i></label>
              <input class="form-check checkbox-gigante" type="checkbox" name="percentualGarantidoEmbutidoTaxaStopLoss"
                ngDefaultControl formControlName="percentualGarantidoEmbutidoTaxaStopLoss" />
            </div>

            <div class="bn-form-group col-md-3">
              <label><b> Indicador aditivo habilitado</b> </label>
              <input class="form-check checkbox-gigante" type="checkbox" name="indicadorAditivoHabilitado"
                ngDefaultControl formControlName="indicadorAditivoHabilitado" />
            </div>

            <div class="bn-form-group col-md-3">
              <label><b> Lim. especial habilitado&ensp;</b>
                <i class="fa fa-question-circle help-subtitulo" placement="top-right" ngbTooltip="
                 Indica se a tranche tem previsão de limite especial"></i></label>
              <input class="form-check checkbox-gigante" type="checkbox" name="indicadorLimiteEspecialHabilitado"
                ngDefaultControl formControlName="indicadorLimiteEspecialHabilitado">
            </div>

          </div>
        </ng-template>
      </li>

      <li *ngIf="mostraAbas" [ngbNavItem]="'historico'" id="historico" title="Histórico">
        <button ngbNavLink>Histórico</button>
        <ng-template ngbNavContent>
          <bn-paginacao [total]="countHistoricos" [tamanhoPagina]="atributosPaginacao.pageSize"
            [numPagina]="atributosPaginacao.page" [opcoesTamanhoPagina]="opcoesPaginacao"
            (aoMudar)="mudancaPagina($event)">
            <div class="table-responsive">
              <table class="table table-hover">
                <thead>
                  <tr>
                    <th class="removeTopBorder" scope="col"><b>ID</b></th>
                    <th class="removeTopBorder" scope="col"><b>Data</b></th>
                    <th class="removeTopBorder" scope="col"><b>Usuário responsável</b></th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let item of listaHistoricos" id="pointer" [routerLink]=""
                    (click)="buscarHistorico(item.id)">
                    <td>{{item.id}}</td>
                    <td>{{item.dataCriacao | date: "dd/MM/yyyy HH:mm"}}</td>
                    <td>{{item.usuarioResponsavel}}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </bn-paginacao>
        </ng-template>
      </li>

      <li *ngIf="mostraAbas" [ngbNavItem]="'fator-redutor-stop-loss'" id="fator-redutor-stop-loss"
        title="Fator Redutor Stop Loss">
        <button ngbNavLink>Fator Redutor Stop Loss</button>
        <ng-template ngbNavContent>
          <div class="d-flex flex-column">

            <button *ngIf="permissaoEdicao" class="btn btn-primary align-self-end mb-3"
              (click)="abrirModalFatorRedutor('Modal com body sendo uma template', 'lg', true, true);"><i
                class="fa fa-file-signature">
              </i>Adicionar Fator Redutor Stop Loss
            </button>

            <div class="table-responsive">
              <table class="table table-hover">
                <thead>
                  <tr>
                    <th class="removeTopBorder" scope="col"><b>Fator Redutor Stop Loss</b></th>
                    <th class="removeTopBorder" scope="col"><b>Limite Inferior Taxa Mensal (%)</b></th>
                    <th class="removeTopBorder" scope="col"><b>Limite Superior Taxa Mensal (%)</b></th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let item of model.fatoresRedutores">
                    <td>{{item.fatorRedutor | bnMask: 'DECIMAL': '2'}}</td>
                    <td>{{item.limiteInferior | bnMask: 'DECIMAL': '2'}}</td>
                    <td>{{item.limiteSuperior | bnMask: 'DECIMAL': '2'}}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </ng-template>
      </li>

      <li *ngIf="mostraAbas" [ngbNavItem]="'taxa-stop-loss'" id="taxa-stop-loss" title="Taxa de Stop Loss">
        <button ngbNavLink>Taxa de Stop Loss</button>
        <ng-template ngbNavContent>
          <div class="d-flex flex-column">

            <button *ngIf="permissaoEdicao" class="btn btn-primary align-self-end mb-3"
              (click)="abrirModalTaxaStopLoss('Modal com body sendo uma template', 'lg', true, true);"><i
                class="fa fa-file-signature">
              </i>Adicionar Taxa de Stop Loss
            </button>

            <div class="table-responsive">
              <table class="table table-hover">
                <thead>
                  <tr>
                    <th class="removeTopBorder" scope="col"><b>Data Inicial Validade</b></th>
                    <th class="removeTopBorder" scope="col"><b>Data Final Validade</b></th>
                    <th class="removeTopBorder" scope="col"><b>Sigla Porte Benificiário</b></th>
                    <th class="removeTopBorder" scope="col"><b>Taxa</b></th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let item of model.taxasStopLoss">
                    <td>{{item.dataInicioValidade | date: "dd/MM/yyyy"}}</td>
                    <td>{{item.dataFimValidade | date: "dd/MM/yyyy"}}</td>
                    <td>{{ nomePortePorSigla(item.siglaPorteBeneficiario) }}</td>
                    <td>{{item.taxa | bnMask: 'DECIMAL': '2'}}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </ng-template>
      </li>

      <li *ngIf="mostraAbas" [ngbNavItem]="'limite-contratacao-beneficiario'" id="limite-contratacao-beneficiario"
        title="Limite Contratação Beneficiário">
        <button ngbNavLink>Limite Contratação Beneficiário</button>
        <ng-template ngbNavContent>
          <div class="d-flex flex-column">

            <div class="d-flex justify-content-between align-items-center mb-3">

              <h6 class="subTitulo mb-0">Limite Beneficiário por Agente Financeiro</h6>

              <button *ngIf="permissaoEdicao" class="btn btn-primary"
                (click)="abrirModalLimiteContratacaoBeneficiario('Modal com body sendo uma template', 'lg', true, true);"><i
                  class="fa fa-file-signature">
                </i>Adicionar Limite Beneficiário por Agente Financeiro
              </button>
            </div>

            <div class="table-responsive">
              <table class="table table-hover">
                <thead>
                  <tr>
                    <th class="removeTopBorder" scope="col"><b>Data Inicial Validade</b></th>
                    <th class="removeTopBorder" scope="col"><b>Data Final Validade</b></th>
                    <th class="removeTopBorder" scope="col"><b>Valor</b></th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let item of model.historicoValorLimiteTotalBeneficiario">
                    <td>{{item.dataInicioValidade | date: "dd/MM/yyyy"}}</td>
                    <td>{{item.dataFimValidade | date: "dd/MM/yyyy"}}</td>
                    <td>{{item.valor | bnMask: 'MOEDA'}}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </ng-template>
      </li>

      <li *ngIf="mostraAbas && mostraAbaLimiteOperacao" [ngbNavItem]="'limite-contratacao-operacao'"
        id="limite-contratacao-operacao" title="Limite Contratação Operação">
        <button ngbNavLink>Limite Contratação Operação</button>
        <ng-template ngbNavContent>
          <div class="d-flex justify-content-between align-items-center mb-3">
            <h6 class="subTitulo mb-0">Limite Contratação Operação</h6>

            <button *ngIf="permissaoEdicao" class="btn btn-primary"
              (click)="abrirModalLimiteContratacaoOperacao('Modal com body sendo uma template', 'lg', true, true);"><i
                class="fa fa-file-signature">
              </i>Adicionar Limite Contratação Operação
            </button>
          </div>

          <div class="table-responsive">
            <table class="table table-hover">
              <thead>
                <tr>
                  <th class="removeTopBorder" scope="col"><b>Data Inicial Validade</b></th>
                  <th class="removeTopBorder" scope="col"><b>Data Final Validade</b></th>
                  <th class="removeTopBorder" scope="col"><b>Objetivo do Financiamento</b></th>
                  <th class="removeTopBorder" scope="col"><b>Sigla Porte Beneficiário</b></th>
                  <th class="removeTopBorder" scope="col"><b>Valor</b></th>
                  <th *ngIf="permissaoEdicao" class="removeTopBorder"></th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let item of model.historicoValorLimiteTotalOperacao"
                  [ngClass]="( rowDisabled(item) ? 'fundo-inativo' : '')">
                  <td>{{item.dataInicioValidade | date: "dd/MM/yyyy"}}</td>
                  <td>{{item.dataFimValidade | date: "dd/MM/yyyy"}}</td>
                  <td>{{item.objetivoFinanciamento == 'G'? 'Giro' : item.objetivoFinanciamento == 'I'?
                    'Investimento' : ''}}</td>
                  <td>{{ nomePortePorSigla(item.siglaPorte) }}</td>
                  <td>{{item.valor | bnMask: 'MOEDA'}}</td>

                  <td *ngIf="permissaoEdicao" class="text-start" id="col-acoes">
                    <a *ngIf="!exibirExcluirOuEncerrar(item.dataInicioValidade) && deveExibirBotaoExcluirEncerrarLimiteContratacao(item)"
                      href="javascript:void(0)" (click)="abrirExcluirEncerrarLimiteOperacao($event, item, item.id)">
                      <i class="fa fa-trash text-danger cursor-pointer margin-left-5" placement="left-top"
                        ngbTooltip="Excluir limite"></i>
                    </a>
                    <a *ngIf="exibirExcluirOuEncerrar(item.dataInicioValidade) && deveExibirBotaoExcluirEncerrarLimiteContratacao(item)"
                      href="javascript:void(0)" (click)="abrirExcluirEncerrarLimiteOperacao($event, item, item.id)">
                      <i class="fa fa-ban text-danger cursor-pointer margin-left-5" placement="left-top"
                        ngbTooltip="Encerrar vigência do Limite Contratação Operaçã"></i>
                    </a>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </ng-template>
      </li>

      <li *ngIf="mostraAbas && mostraAbaPrazosContratacao" [ngbNavItem]="'prazos-contratacao'" id="prazos-contratacao"
        title="Prazos de Contratação">
        <button ngbNavLink>Prazos de Contratação</button>
        <ng-template ngbNavContent>
          <div class="d-flex flex-column">
            <button *ngIf="permissaoEdicao" class="btn btn-primary align-self-end mb-3"
              (click)="abrirModalPrazoContratacao('Modal com body sendo uma template', 'lg', true, true);"><i
                class="fa fa-file-signature">
              </i>Adicionar Prazos de Contratação
            </button>
            <div class="table-responsive">
              <table class="table table-hover">
                <thead>
                  <tr>
                    <th class="removeTopBorder" scope="col"><b>Data Inicial Validade</b></th>
                    <th class="removeTopBorder" scope="col"><b>Data Final Validade</b></th>
                    <th class="removeTopBorder" scope="col"><b>Prazo carência mínimo (meses)</b></th>
                    <th class="removeTopBorder" scope="col"><b>Prazo carência máximo (meses)</b></th>
                    <th class="removeTopBorder" scope="col"><b>Prazo total mínimo (meses)</b></th>
                    <th class="removeTopBorder" scope="col"><b>Prazo total máximo (meses)</b></th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let prazo of model.prazosContratacao">
                    <td>{{prazo.dataInicioValidade | date: "dd/MM/yyyy"}}</td>
                    <td>{{prazo.dataFimValidade | date: "dd/MM/yyyy"}}</td>
                    <td>{{prazo.quantidadeMesesPrazoMinimoCarencia}}</td>

                    <td>
                      <ng-container *ngIf="prazo.quantidadeMesesPrazoMaximoCarencia; else semMaxCarencia">
                        {{ prazo.quantidadeMesesPrazoMaximoCarencia }}
                      </ng-container>
                      <ng-template #semMaxCarencia>-</ng-template>
                    </td>

                    <td>{{prazo.quantidadeMesesPrazoMinimoTotal}}</td>

                    <td>
                      <ng-container *ngIf="prazo.quantidadeMesesPrazoMaximoTotal; else semMaxTotal">
                        {{ prazo.quantidadeMesesPrazoMaximoTotal }}
                      </ng-container>
                      <ng-template #semMaxTotal>-</ng-template>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </ng-template>
      </li>

      <li *ngIf="mostraAbas && exibeAbaFatorK" [ngbNavItem]="'fatores de ecg'" id="fatores de ecg" title="Fator K">
        <button ngbNavLink>Fator K</button>
        <ng-template ngbNavContent>
          <div class="d-flex flex-column">

            <button *ngIf="permissaoEdicao && dataFimDaTranche > dataAtual" class="btn btn-primary align-self-end mb-3"
              (click)="abrirModalNovaVigenciaFatorEcg('Modal com body sendo uma template', 'lg', true, true);"><i
                class="fa fa-file-signature">
              </i>Criar Nova Vigência de Fatores
            </button>

            <div class="table-responsive">
              <table class="table table-hover">
                <thead>
                  <tr>
                    <th class="removeTopBorder" scope="col"><b>ID</b></th>
                    <th class="removeTopBorder" scope="col"><b>Data Inicial Validade</b></th>
                    <th class="removeTopBorder" scope="col"><b>Data Final Validade</b></th>
                    <th *ngIf="permissaoEdicao" class="removeTopBorder"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr id="pointer" *ngFor="let vigencia of vigenciasFatorEcg; let i = index"
                    (click)="abrirModalVigenciaFatorEcg('Modal com body sendo uma template', 'lg', true, true, vigencia)">
                    <td>{{vigencia.id}}</td>
                    <td>{{vigencia.dataInicioVigencia | date: "dd/MM/yyyy"}}</td>
                    <td>{{vigencia.dataFimVigencia | date: "dd/MM/yyyy"}}</td>

                    <td *ngIf="permissaoEdicao" class="text-start" id="col-acoes">
                      <a *ngIf="podeExcluir(vigencia.dataInicioVigencia, i)" href="javascript:void(0)"
                        (click)="abrirExcluirVigenciaFatorEcg($event, vigencia.id)">
                        <i class="fa fa-trash cursor-pointer margin-left-5" placement="left-top"
                          ngbTooltip="Excluir vigência"></i>
                      </a>
                      <a href="javascript:void(0)" (click)="abrirModalDuplicaVigencia($event, vigencia.id)">
                        <i class="fa fa-copy cursor-pointer text-success margin-left-5" placement="left-top"
                          ngbTooltip="Duplicação de tabela. Permite criar tabela de fator, a partir dos dados de outra pré-existente"></i>
                      </a>
                      <a *ngIf="!vigencia.dataFimVigencia" href="javascript:void(0)"
                        (click)="abrirModalEncerrarVigenciaFatorEcg($event, 'Modal com body sendo uma template', 'lg', true, true, vigencia)">
                        <i class="fa fa-ban cursor-pointer text-danger margin-left-5" placement="left-top"
                          ngbTooltip="Encerrar vigência do Fator K"></i>
                      </a>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </ng-template>
      </li>

      <li *ngIf="mostraAbas && exibeAbaFatorK" [ngbNavItem]="'reducao_ecg'" id="reducao_ecg" title="% Redução ECG">
        <button ngbNavLink>% Redução ECG</button>
        <ng-template ngbNavContent>
          <div class="d-flex flex-column">

            <button *ngIf="permissaoEdicao" class="btn btn-primary align-self-end mb-3"
              (click)="abrirModalNovoFatorRedutorEcg('Modal com body sendo uma template', 'lg', true, true);"><i
                class="fa fa-file-signature">
              </i> Adicionar % Redução ECG
            </button>

            <div class="table-responsive">
              <table class="table table-hover">
                <thead>
                  <tr>
                    <th class="removeTopBorder" scope="col"><b>Data Inicial Validade</b></th>
                    <th class="removeTopBorder" scope="col"><b>Data Final Validade</b></th>
                    <th class="removeTopBorder" scope="col"><b>% Redução ECG</b></th>
                    <th *ngIf="permissaoEdicao" class="removeTopBorder" scope="col"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let fator of fatoresReducaoEcg; let i = index">
                    <td>{{fator.dataInicioVigencia | date: "dd/MM/yyyy"}}</td>
                    <td>{{fator.dataFimVigencia | date: "dd/MM/yyyy"}}</td>
                    <td>{{fator.valorFatorRedutorEcg | percent: '2.2-8'}}</td>

                    <td *ngIf="permissaoEdicao" class="text-start" id="col-acoes">
                      <a *ngIf="podeExcluirFatorRedutor(fator)" href="javascript:void(0)"
                        (click)="modalExcluirFatorRedutorEcg($event, fator.id)">
                        <i class="fa fa-trash cursor-pointer margin-left-5" placement="left-top"
                          ngbTooltip="Excluir vigência"></i>
                      </a>
                      <a *ngIf="podeEncerrarFatorRedutor(fator)" href="javascript:void(0)"
                        (click)="modalEncerrarFatorRedutorEcg($event, fator)">
                        <i class="fa fa-ban cursor-pointer margin-left-5" placement="left-top"
                          ngbTooltip="Encerrar vigência do %Redução ECG"></i>
                      </a>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </ng-template>
      </li>

      <li *ngIf="mostraAbas && exibeAbaEventosDistribuicao" [ngbNavItem]="'evento distribuicao'"
        id="evento distribuicao" title="Eventos de Distribuição de Limites">
        <button ngbNavLink>Eventos de Distribuição de Limites</button>
        <ng-template ngbNavContent>
          <div class="d-flex flex-column">

            <button *ngIf="permissaoEdicao" class="btn btn-primary align-self-end mb-3"
              (click)="abrirModalEventoDistribuicao('Modal com body sendo uma template', 'lg', true, true);"><i
                class="fa fa-file-signature">
              </i>Cadastrar Retorno Agente Financeiro
            </button>

            <div class="table-responsive">
              <table class="table table-hover">
                <thead>
                  <tr>
                    <th class="removeTopBorder" scope="col"><b>Agente Financeiro</b></th>
                    <th class="removeTopBorder" scope="col"><b>Data Evento</b></th>
                    <th class="removeTopBorder" scope="col"><b>Tipo do Evento</b></th>
                    <th class="removeTopBorder" scope="col"><b>Ações</b></th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let evento of eventosDistribuicao">
                    <td>{{evento.agenteFinanceiro.nome}}</td>
                    <td>{{evento.dataEvento | date: "dd/MM/yyyy"}}</td>
                    <td>{{evento.tipoEvento}}</td>
                    <td>
                      <a *ngIf="evento.tipoEvento === 'CANCELAMENTO'"
                        title="Acessar lista de ciclos em que a meta foi descumprida"
                        aria-label="Acessar lista de ciclos em que a meta foi descumprida"
                        (click)="buscarCiclosMetaDescumprida(evento); $event.stopPropagation();">
                          <i class="fa fa-list fa-fw small icon-widget" aria-hidden="true"></i>
                      </a>
                    </td>                    
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </ng-template>

        <ng-template #modalCiclosMetaDescumprida let-modal>
          <div class="modal-header ps-2">
            <h5 class="modal-title mb-0">Ciclos cujas utilizações foram inferior a 5% do limite disponível*</h5>
            <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
          </div>

          <div class="modal-body">
            <div class="table-responsive">
              <table class="table table-striped table-hover table-sm">
                <thead>
                  <tr>
                    <th>Data inicial do ciclo</th>
                    <th>Data final do ciclo</th>
                  </tr>
                </thead>

                <tbody *ngIf="listaCiclosMetaDescumprida?.length > 0; else nenhumCicloMetaDescumprida">
                  <tr *ngFor="let item of listaCiclosMetaDescumprida">
                    <td>{{ item.dataInicio | date:'dd/MM/yyyy' }}</td>
                    <td>{{ item.dataFim | date:'dd/MM/yyyy' }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div class="modal-footer">
            <small class="text-muted">
              *Os Agentes Financeiros que tiveram utilização do Limite Disponível 
              inferior a 10% em algum período até 30 de junho de 2023, 
              preservarão a condição de não atendimento da utilização do Limite Disponível para esse item.
            </small>
          </div>
        </ng-template>

        <ng-template #nenhumCicloMetaDescumprida>
          <tbody>
            <tr>
              <td colspan="2" class="text-center text-muted py-4">
                Nenhum ciclo foi encontrado para o evento selecionado.
              </td>
            </tr>
          </tbody>
        </ng-template>
      </li>

      <li *ngIf="mostraAbas" [ngbNavItem]="'porte_beneficiario'" id="porte_beneficiario" title="Porte Beneficiário">
        <button ngbNavLink>Porte Beneficiário</button>
        <ng-template ngbNavContent>
          <div class="d-flex justify-content-between align-items-center mb-3">

            <div class="d-flex align-items-center">
              <input type="checkbox" class="form-check checkbox-gigante" name="verPortesDesativados"
                [(ngModel)]="verPortesDesativados" [ngModelOptions]="{standalone: true}"
                (change)="changeVerPortesDesativados()">
              <label class="form-check-label ms-2" for="verPortesDesativados"><b>Ver portes desativados</b></label>
            </div>

            <button *ngIf="permissaoEdicao" class="btn btn-primary"
              (click)="abrirModalPorteBeneficiario('Modal com body sendo uma template', 'lg', true, true);"><i
                class="fa fa-file-signature">
              </i>Adicionar Porte Beneficiário
            </button>

          </div>
          <div class="table-responsive">
            <table class="table table-hover">
              <thead>
                <tr>
                  <th class="removeTopBorder text-center" scope="col"><b>Data Inicial Validade</b></th>
                  <th class="removeTopBorder text-center" scope="col"><b>Data Final Validade</b></th>
                  <th class="removeTopBorder text-center" scope="col"><b>Sigla Porte Beneficiário</b></th>
                  <th class="removeTopBorder text-center" scope="col"><b>Faturamento Mínimo R$</b></th>
                  <th class="removeTopBorder text-center" scope="col"><b>Faturamento Máximo R$</b></th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let porte of porteBeneficiario">
                  <td class="text-center">{{porte.dataInicioValidade | date: "dd/MM/yyyy"}}</td>
                  <td class="text-center">{{porte.dataFimValidade | date: "dd/MM/yyyy"}}</td>
                  <td class="text-center">{{porte.porteEmpresa}}</td>
                  <td class="text-center">{{porte.faturamentoMinimo | bnMask: 'MOEDA'}}</td>
                  <td class="text-center">{{porte.faturamentoMaximo | bnMask: 'MOEDA'}}</td>
                  <td *ngIf="permissaoEdicao" class="text-start" id=col-acoes>
                    <a *ngIf="!exibirExcluirPorte(porte.dataInicioValidade) && deveExibirBotaoexcluirPorteBeneficiario(porte)"
                      href="javascript:void(0)" (click)="abrirExcluirPorteBeneficiario($event, porte)">
                      <i class="fa fa-trash text-danger cursor-pointer margin-left-5" placement="left-top"
                        ngbTooltip="Excluir a vigência do Porte Beneficiário"></i>
                    </a>
                    <a *ngIf="exibirExcluirPorte(porte.dataInicioValidade) && porte.dataFimValidade == null"
                      href="javascript:void(0)" (click)="abrirEncerrarPorteBeneficiario($event, porte)">
                      <i class="fa fa-ban text-danger cursor-pointer margin-left-5" placement="left-top"
                        ngbTooltip="Encerrar vigência do Porte Beneficiário"></i>
                    </a>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </ng-template>
      </li>
    </ul>
    <div [ngbNavOutlet]="nav" class="mt-2"></div>
  </div>

  <app-tranche-historico [tranches]="tranches" [historico]="historico" (fechaHistorico)="fecharHistorico()"
    *ngIf="pesquisado && abaAtiva=='historico'">
  </app-tranche-historico>
</div>
<div *ngIf="formFatorRedutor" [formGroup]="formFatorRedutor">
  <ng-template #bodyFatorRedutor>
    <div class="container">
      <div class="row">
        <div class="bn-form-group col">
          <label><b>Fator redutor</b></label>
          <input class="form-control" name="fatorRedutor" formControlName="fatorRedutor" ngDefaultControl
            bnMask="DECIMAL" casasDecimais="2" />
        </div>
        <div class="bn-form-group col">
          <label><b>Limite inferior Taxa Anual (%)</b></label>
          <input class="form-control" name="limiteInferior" formControlName="limiteInferior" ngDefaultControl
            bnMask="DECIMAL" casasDecimais="2" />
        </div>
        <div class="bn-form-group col">
          <label><b>Limite superior Taxa Anual (%)</b></label>
          <input class="form-control" name="limiteSuperior" formControlName="limiteSuperior" ngDefaultControl
            bnMask="DECIMAL" casasDecimais="2" />
        </div>
      </div>
    </div>
  </ng-template>

  <ng-template #botoesFatorRedutor>
    <button class="btn btn-danger" (click)="fecharModalFatorRedutor()">Fechar</button>
    <button class="btn btn-success" [disabled]="(!formFatorRedutor.valid)"
      (click)="salvarFatorRedutor()">Salvar</button>
  </ng-template>
</div>

<div *ngIf="formTaxaStopLoss" [formGroup]="formTaxaStopLoss">
  <ng-template #bodyTaxaStopLoss>
    <div class="container">
      <div class="row">
        <div class="col">
        </div>
      </div>
      <div class="row">
        <div class="bn-form-group col">
          <label><b>Data início validade</b></label>
          <bn-datepicker name="dataInicioValidade" [minDate]="dataAmanha" formControlName="dataInicioValidade">
          </bn-datepicker>
        </div>
        <div class="bn-form-group col">
          <label for="siglaPorteBeneficiario"><b>Sigla porte beneficiário</b></label>
          <select id="siglaPorteBeneficiario" class="form-select" formControlName="siglaPorteBeneficiario">
            <option [ngValue]="sigla.sigla" *ngFor="let sigla of siglasPorteBeneficiario">{{ sigla.nome }}</option>
          </select>
        </div>
        <div class="bn-form-group col">
          <label><b>Taxa</b></label>
          <input class="form-control" name="taxa" formControlName="taxa" bnMask="DECIMAL" casasDecimais="2" />
        </div>
      </div>
    </div>
  </ng-template>

  <ng-template #botoesTaxaStopLoss>
    <button class="btn btn-danger" (click)="fecharModalTaxaStopLoss()">Fechar</button>
    <button class="btn btn-success" [disabled]="!formTaxaStopLoss.valid" (click)="salvarTaxaStopLoss()">Salvar</button>
  </ng-template>
</div>

<div *ngIf="formLimiteContratacaoBeneficiario" [formGroup]="formLimiteContratacaoBeneficiario">
  <ng-template #bodyLimiteContratacaoBeneficiario>
    <div class="container">
      <div class="row">
        <div class="col">
        </div>
      </div>
      <div class="row">
        <div class="bn-form-group col">
          <label class="form-label"><b>Data início validade</b></label>
          <bn-datepicker name="dataInicioValidade" formControlName="dataInicioValidade">
          </bn-datepicker>
        </div>
        <div class="bn-form-group col">
          <label class="form-label"><b>Valor</b></label>
          <input bnMask="MOEDA" class="form-control" name="valor" formControlName="valor" />
        </div>
      </div>
    </div>
  </ng-template>

  <ng-template #botoesLimiteContratacaoBeneficiario>
    <button class="btn btn-danger" (click)="fecharModalLimiteContratacaoBeneficiario()">Fechar</button>
    <button class="btn btn-success" [disabled]="!formLimiteContratacaoBeneficiario.valid"
      (click)="salvarLimiteContratacaoBeneficiario()">Salvar</button>
  </ng-template>

</div>

<div *ngIf="formLimiteContratacaoOperacao" [formGroup]="formLimiteContratacaoOperacao">
  <ng-template #bodyLimiteContratacaoOperacao>
    <div class="container">
      <div class="row">
        <div class="col">
        </div>
      </div>
      <div class="row">
        <div class="bn-form-group col">
          <label class="form-label"><b>Data início validade</b></label>
          <bn-datepicker [minDate]="dataInicioMinimoCadastroLimiteOperacao" name="dataInicioValidade"
            formControlName="dataInicioValidade">
          </bn-datepicker>
        </div>
        <div class="bn-form-group col">
          <label for="objetivoFinanciamento"><b>Objetivo do financiamento</b></label>
          <select id="objetivoFinanciamento" class="form-select" formControlName="objetivoFinanciamento">
            <option [ngValue]=null>Selecione</option>
            <option [ngValue]="objetivo.value" *ngFor="let objetivo of objetivoFinanciamentoSelect">
              {{objetivo.label}}
            </option>
          </select>
        </div>
      </div>
      <div class="row">
        <div class="bn-form-group col">
          <label for="siglaPorte"><b>Sigla Porte Beneficiário</b></label>
          <select id="siglaPorte" class="form-select" formControlName="siglaPorte">
            <option [ngValue]=null>Selecione</option>
            <option [ngValue]="sigla.value" *ngFor="let sigla of siglaPorte">
              {{sigla.label}}
            </option>
          </select>
        </div>
        <div class="bn-form-group col">
          <label class="form-label"><b>Valor</b></label>
          <input bnMask="MOEDA" class="form-control" name="valor" formControlName="valor" />
        </div>
      </div>
    </div>
  </ng-template>

  <ng-template #botoesLimiteContratacaoOperacao>
    <button class="btn btn-danger" (click)="fecharModalLimiteContratacaoOperacao()">Fechar</button>
    <button class="btn btn-success" [disabled]="!formLimiteContratacaoOperacao.valid"
      (click)="salvarLimiteContratacaoOperacao()">Salvar</button>
  </ng-template>

</div>

<div *ngIf="formPrazoContratacao" [formGroup]="formPrazoContratacao">
  <ng-template #bodyPrazoContratacao>
    <div class="container">
      <div class="row">
        <div class="col">
        </div>
      </div>
      <div class="row">
        <div class="bn-form-group col">
          <label class="form-label"><b>Data início validade</b></label>
          <bn-datepicker name="dataInicioValidade" formControlName="dataInicioValidade">
          </bn-datepicker>
        </div>
        <div class="bn-form-group col">
          <label class="form-label"><b>Prazo carência mín. (meses)</b></label>
          <input class="form-control" name="quantidadeMesesPrazoMinimoCarencia"
            formControlName="quantidadeMesesPrazoMinimoCarencia" bnMask='INTEIRO' />
        </div>
        <div class="bn-form-group col">
          <label class="form-label"><b>Prazo carência máx. (meses)</b></label>
          <input class="form-control" name="quantidadeMesesPrazoMaximoCarencia"
            formControlName="quantidadeMesesPrazoMaximoCarencia" bnMask='INTEIRO' />
        </div>
      </div>
      <div class="row">
        <div class="bn-form-group col">
          <label class="form-label"><b>Prazo total mín. (meses)</b></label>
          <input class="form-control" name="quantidadeMesesPrazoMinimoTotal"
            formControlName="quantidadeMesesPrazoMinimoTotal" bnMask='INTEIRO' />
        </div>
        <div class="bn-form-group col">
          <label class="form-label"><b>Prazo total máx. (meses)</b></label>
          <input class="form-control" name="quantidadeMesesPrazoMaximoTotal"
            formControlName="quantidadeMesesPrazoMaximoTotal" bnMask='INTEIRO' />
        </div>
      </div>
    </div>
  </ng-template>

  <ng-template #botoesPrazoContratacao>
    <button class="btn btn-danger" (click)="fecharModalPrazoContratacao()">Fechar</button>
    <button class="btn btn-success" [disabled]="!formPrazoContratacao.valid"
      (click)="salvarPrazoContratacao()">Salvar</button>
  </ng-template>

  <div *ngIf="formEventoDistribuicao" [formGroup]="formEventoDistribuicao">
    <ng-template #bodyEventoDistribuicao>
      <div class="container">
        <div class="row">
          <div class="col">
          </div>
        </div>
        <div class="row">
          <div class="bn-form-group col">
            <label class="form-label"><b>Agente Financeiro</b></label>
            <select class="form-select" name="agenteFinanceiro" formControlName="agenteFinanceiro">
              <option [ngValue]="null"></option>
              <option *ngFor="let agente of agentesFinanceirosHabilitados" [ngValue]="agente">
                {{agente.nome}} ({{agente.cnpj | bnCnpj:"XX.XXX.XXX/XXXX-XX"}})
              </option>
            </select>
          </div>
        </div>
        <div class="row">
          <div class="evento-distribuicao">
            <div class="bn-form-group col" style="padding: 5px;">
              <label class="form-label"><b>Data Evento</b></label>
              <bn-datepicker name="dataEvento" formControlName="dataEvento">
              </bn-datepicker>
            </div>
          </div>
        </div>
      </div>
    </ng-template>

    <ng-template #botoesEventoDistribuicao>
      <button class="btn btn-danger" (click)="fecharModalEventoDistribuicao()">Fechar</button>
      <button class="btn btn-success" [disabled]="!formEventoDistribuicao.valid"
        (click)="salvarEventoDistribuicao()">Salvar</button>
    </ng-template>
  </div>

  <div *ngIf="formNovaVigenciaFatorEcg" [formGroup]="formNovaVigenciaFatorEcg">
    <ng-template #bodyNovaVigenciaFatorEcg>
      <div class="container">
        <div class="row">
          <div class="col">
          </div>
        </div>
        <div class="row">
          <div class="bn-form-group col">
            <label class="form-label"><b>Início da Vigência</b></label>
            <bn-datepicker name="dataInicioVigencia" formControlName="dataInicioVigencia"></bn-datepicker>
          </div>
          <div class="bn-form-group col">
            <label class="form-label"><b>Fim da Vigência</b></label>
            <bn-datepicker name="dataFimVigencia" formControlName="dataFimVigencia"></bn-datepicker>
          </div>
        </div>
      </div>
    </ng-template>

    <ng-template #botoesNovaVigenciaFatorEcg>
      <button class="btn btn-danger" (click)="fecharModalNovaVigenciaFatorEcg()">Fechar</button>
      <button class="btn btn-success" [disabled]="!formNovaVigenciaFatorEcg.valid"
        (click)="salvarNovaVigenciaFatorEcg()">Salvar</button>
    </ng-template>
  </div>

  <div *ngIf="formNovaVigenciaFatorEcg" [formGroup]="formNovaVigenciaFatorEcg">
    <ng-template #bodyDuplicaVigenciaFatorEcg>
      <div class="container">
        <div class="row">
          <div class="col">
          </div>
        </div>
        <div class="row">
          <div class="bn-form-group col">
            <label class="form-label"><b>Início da Vigência</b></label>
            <bn-datepicker name="dataInicioVigencia" formControlName="dataInicioVigencia"></bn-datepicker>
          </div>
          <div class="bn-form-group col">
            <label class="form-label"><b>Fim da Vigência</b></label>
            <bn-datepicker name="dataFimVigencia" formControlName="dataFimVigencia"></bn-datepicker>
          </div>
        </div>
      </div>
    </ng-template>

    <ng-template #botoesDuplicaVigenciaFatorEcg>
      <button class="btn btn-danger" (click)="fecharModalNovaVigenciaFatorEcg()">Fechar</button>
      <button class="btn btn-success" [disabled]="!formNovaVigenciaFatorEcg.valid"
        (click)="duplicaVigenciaFatorEcg()">Salvar</button>
    </ng-template>
  </div>

  <div *ngIf="formNovoFatorRedutorEcg" [formGroup]="formNovoFatorRedutorEcg">
    <ng-template #bodyNovoFatorRedutorEcg>
      <div class="container">
        <div class="row">
          <div class="col">
          </div>
        </div>
        <div class="row">
          <div class="bn-form-group col">
            <label class="form-label"><b>Data início da validade *</b></label>
            <bn-datepicker name="dataInicioVigencia" formControlName="dataInicioVigencia"
              [minDate]="dataAtual"></bn-datepicker>
          </div>
          <div class="bn-form-group col">
            <label class="form-label"><b>% Redução ECG *</b></label>
            <input class="form-control" name="valorFatorRedutorEcg" formControlName="valorFatorRedutorEcg"
              maxlength="8" />
          </div>
        </div>
      </div>
    </ng-template>

    <ng-template #botoesNovoFatorRedutorEcg>
      <button class="btn btn-danger" (click)="fecharModalNovoFatorRedutorEcg()">Fechar</button>
      <button class="btn btn-success" [disabled]="!formNovoFatorRedutorEcg.valid"
        (click)="salvarNovoFatorRedutorEcg()">Salvar</button>
    </ng-template>
  </div>

  <div *ngIf="formVigenciaFatorEcg" [formGroup]="formVigenciaFatorEcg">
    <ng-template #bodyVigenciaFatorEcg>
      <div class="container">
        <div class="row">
          <div class="col">
          </div>
        </div>
        <div class="row">
          <div class="bn-form-group col">
            <label><b>Início da Vigência</b></label>
            <bn-datepicker name="dataInicioVigencia" formControlName="dataInicioVigencia"></bn-datepicker>

          </div>
          <div class="bn-form-group col">
            <label><b>Fim da Vigência</b></label>
            <bn-datepicker name="dataFimVigencia" formControlName="dataFimVigencia"></bn-datepicker>
          </div>
        </div>
        <button *ngIf="permissaoEditar && permissaoEdicao" id="btn-adicionarFator" class="btn btn-primary"
          (click)="abrirModalFatorEcg()">Adicionar Fator</button>
        <div *ngIf="!encerrarFator" class="row">
          <div class="bn-form-group col" id="table-container">
            <h5 class="form-label"><b>Fatores de ECG</b></h5>
            <table class="table table-hover">
              <thead>
                <tr>
                  <th class="removeTopBorder" scope="col"><b>Qtde. Meses Prazo Inicial</b></th>
                  <th class="removeTopBorder" scope="col"><b>Qtde. Meses Prazo Final</b></th>
                  <th class="removeTopBorder" scope="col"><b>Valor do Fator (%)</b></th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let fator of vigenciaFatorEcg.fatoresEcg; let indexItem = index">
                  <td>{{fator.quantidadeMesesPrazoTotalInicial}}</td>
                  <td>{{fator.quantidadeMesesPrazoTotalFinal}}</td>
                  <td>{{fator.valorFatorEcg | number:'1.2-2'}}</td>
                  <td>
                    <a href="javascript:void(0)" *ngIf="permissaoEditar && permissaoEdicao"
                      (click)="abrirModalFatorEcg(fator)">
                      <i class="fa fa-pencil cursor-pointer margin-left-5" placement="left-top" ngbTooltip="Editar"></i>
                    </a>
                    <a href="javascript:void(0)" *ngIf="permissaoEditar && permissaoEdicao"
                      (click)="excluirFator(indexItem)">
                      <i class="fa fa-trash cursor-pointer margin-left-5" placement="left-top" ngbTooltip="Excluir"></i>
                    </a>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </ng-template>

    <ng-template #botoesVigenciaFatorEcg>
      <button class="btn btn-danger" (click)="fecharModalVigenciaFatorEcg()">Fechar</button>
      <button class="btn btn-success" *ngIf="permissaoSalvar && permissaoEdicao"
        (click)="salvarVigenciaFatorEcg(vigenciaFatorEcg.id)">Salvar</button>
    </ng-template>

    <ng-template #msgTemplateExcluir>
      Está ação irá excluir a vigência selecionada.
      <br />
      <br />
      Você confirma?
      <br />
    </ng-template>
    <ng-template #botoesPersonalizadosExcluir>
      <button class="btn btn-md btn-success" (click)="excluirFatorEcg()">
        Sim
      </button>
      <button class="btn btn-md btn-danger" (click)="close()">
        Não
      </button>
    </ng-template>

    <ng-template #msgTemplateExcluirLimiteContratacaoOperacao>
      Está ação irá EXCLUIR o limite de contratação selecionado.
      <br />
      <br />
      Você confirma?
      <br />
    </ng-template>
    <ng-template #botoesPersonalizadosExcluirLimiteContratacaoOperacao>
      <button class="btn btn-md btn-success" (click)="excluirLimiteContratacaoOperacao()">
        Sim
      </button>
      <button class="btn btn-md btn-danger" (click)="close()">
        Não
      </button>
    </ng-template>

    <ng-template #msgTemplateExcluirFatorRedutor>
      Está ação irá EXCLUIR o % Redução ECG selecionado.
      <br />
      <br />
      Você confirma?
      <br />
    </ng-template>
    <ng-template #botoesExcluirFatorRedutor>
      <button class="btn btn-md btn-success" (click)="excluirFatorRedutorEcg()">
        Sim
      </button>
      <button class="btn btn-md btn-danger" (click)="close()">
        Não
      </button>
    </ng-template>

    <div *ngIf="formEncerrarLimiteContratacaoOperacao" [formGroup]="formEncerrarLimiteContratacaoOperacao">
      <ng-template #msgTemplateEncerrarLimiteContratacaoOperacao>
        <div class="container">
          <div class="row">
            <div class="col">
            </div>
          </div>
          <div class="row">
            <div class="bn-form-group col">
              <label class="form-label"><b>Data Inicial validade</b></label>
              <bn-datepicker disabled name="dataInicioValidade" formControlName="dataInicioValidade"></bn-datepicker>
            </div>
            <div class="bn-form-group col">
              <label class="form-label"><b>Data Final validade</b></label>
              <bn-datepicker name="dataFimValidade" formControlName="dataFimValidade"
                [minDate]="dataAtual"></bn-datepicker>
            </div>
          </div>
        </div>
      </ng-template>
      <ng-template #botoesPersonalizadosEncerrarLimiteContratacaoOperacao>
        <button class="btn btn-md btn-danger" (click)="close()">
          Fechar
        </button>
        <button class="btn btn-md btn-success" (click)="encerrarLimiteContratacaoOperacao()">
          Salvar
        </button>
      </ng-template>
    </div>

    <div *ngIf="formEncerrarFatorRedutorEcg" [formGroup]="formEncerrarFatorRedutorEcg">
      <ng-template #msgTemplateEncerrarFatorRedutor>
        <div class="container">
          <div class="row">
            <div class="col">
            </div>
          </div>
          <div class="row">
            <div class="bn-form-group col">
              <label class="form-label"><b>Data Incial validade</b></label>
              <bn-datepicker name="dataInicioVigencia" formControlName="dataInicioVigencia"></bn-datepicker>
            </div>
            <div class="bn-form-group col">
              <label class="form-label"><b>Data Final validade *</b></label>
              <bn-datepicker name="dataInicioVigencia" formControlName="dataFimVigencia"
                [minDate]="dataAtual"></bn-datepicker>
            </div>
          </div>
        </div>
      </ng-template>
      <ng-template #botoesEncerrarFatorRedutor>
        <button class="btn btn-md btn-success" (click)="encerrarFatorRedutorEcg()">
          Salvar
        </button>
        <button class="btn btn-md btn-danger" (click)="close()">
          Fechar
        </button>
      </ng-template>
    </div>

    <div *ngIf="formPorteBeneficario" [formGroup]="formPorteBeneficario">
      <ng-template #msgTemplatePorteBeneficiario>
        <div class="container">
          <div class="row">
            <div class="col">
            </div>
          </div>
          <div class="row">
            <div class="bn-form-group col">
              <label class="form-label"><b>Data Incial validade</b></label>
              <bn-datepicker name="dataInicioValidade" formControlName="dataInicioValidade"
                [minDate]="dataAmanha"></bn-datepicker>
            </div>
            <div class="bn-form-group col">
              <label class="form-label"><b>Data Final validade</b></label>
              <bn-datepicker name="dataFimValidade" formControlName="dataFimValidade"
                [minDate]="dataAmanha"></bn-datepicker>
            </div>
            <div class="bn-form-group col">
              <label for="porteEmpresa"><b>Sigla Porte Beneficiário</b></label>
              <select id="porteEmpresa" class="form-select" formControlName="porteEmpresa">
                <option [ngValue]=null>Selecione</option>
                <option [ngValue]="sigla.sigla" *ngFor="let sigla of siglasPorteBeneficiario">
                  {{sigla.nome}}
                </option>
              </select>
            </div>
          </div>
          <div class="row">
            <div class="bn-form-group col">
              <label class="form-label"><b>Faturamento Mínimo R$</b></label>
              <input bnMask="MOEDA" class="form-control" name="faturamentoMinimo" formControlName="faturamentoMinimo" />
            </div>
            <div class="bn-form-group col">
              <label class="form-label"><b>Faturamento Máximo R$</b></label>
              <input bnMask="MOEDA" class="form-control" name="faturamentoMaximo" formControlName="faturamentoMaximo" />
            </div>
          </div>
        </div>
      </ng-template>
      <ng-template #botoesPorteBeneficiario>
        <button class="btn btn-md btn-success" [disabled]="!formPorteBeneficario.valid"
          (click)="salvarPorteBeneficiario()">
          Salvar
        </button>
        <button class="btn btn-md btn-danger" (click)="fecharModalPorteBeneficiario()">
          Fechar
        </button>
      </ng-template>
    </div>

    <div *ngIf="formEncerrarPorteBeneficiario" [formGroup]="formEncerrarPorteBeneficiario">
      <ng-template #msgTemplateEncerrarPorteBeneficiario>
        <div class="container">
          <div class="row">
            <div class="col">
            </div>
          </div>
          <div class="row">
            <div class="bn-form-group col">
              <label class="form-label"><b>Data Inicial validade</b></label>
              <bn-datepicker disabled name="dataInicioValidade" formControlName="dataInicioValidade"></bn-datepicker>
            </div>
            <div class="bn-form-group col">
              <label class="form-label"><b>Data Final validade</b></label>
              <bn-datepicker name="dataFimValidade" formControlName="dataFimValidade"
                [minDate]="dataAtual"></bn-datepicker>
            </div>
          </div>
        </div>
      </ng-template>
      <ng-template #botoesPersonalizadosEncerrarPorteBeneficiario>
        <button class="btn btn-md btn-danger" (click)="fecharModalEncerrarPorteBeneficiario()">
          Fechar
        </button>
        <button class="btn btn-md btn-success" (click)="encerrarPorteBeneficiario()">
          Salvar
        </button>
      </ng-template>
    </div>
    <ng-template #msgTemplateExcluirPorteBeneficiario>
      Está ação irá EXCLUIR o Porte Beneficiário selecionado.
      <br />
      <br />
      Você confirma?
      <br />
    </ng-template>
    <ng-template #botoesPersonalizadosExcluirPorteBeneficiario>
      <button class="btn btn-md btn-success" (click)="excluirPorteBeneficiario()">
        Sim
      </button>
      <button class="btn btn-md btn-danger" (click)="close()">
        Não
      </button>
    </ng-template>

  </div>

  <!--div *ngIf="formFatorEcg" [formGroup]="formFatorEcg">
  <ng-template #bodyFatorEcg>
    <div class="container">
      <div class="row">
        <div class="col">
        </div>
      </div>
      <div class="row">
        <div class="bn-form-group col">
          <label class="form-label"><b>QTDE. MESES PRAZO INICIAL:</b></label>
          <input bnMask="DECIMAL" class="form-control" name="quantidadeMesesPrazoTotalInicial"
          formControlName="quantidadeMesesPrazoTotalInicial"/>
        </div>
        <div class="bn-form-group col">
          <label class="form-label"><b>QTDE. MESES PRAZO FINAL</b></label>
          <input bnMask="DECIMAL" class="form-control" name="quantidadeMesesPrazoTotalFinal"
          formControlName="quantidadeMesesPrazoTotalFinal"/>
        </div>
        <div class="bn-form-group col">
          <label class="form-label"><b>VALOR DO FATOR (%)</b></label>
          <input bnMask="DECIMAL" class="form-control" name="valorFatorEcg"
          formControlName="valorFatorEcg"/>
        </div>
      </div>
    </div>
  </ng-template>

  <ng-template #botoesFatorEcg>
    <button class="btn btn-danger" (click)="fecharModalFatorEcg()">Fechar</button>
    <button *ngIf="ehCadastroVigencia || !vigenciaFatorEcg.dataFimVigencia"
    class="btn btn-success" [disabled]="!formFatorEcg.valid" (click)="salvarFatorEcg()">Salvar</button>
  </ng-template>
</div-->